import React from 'react';
import {
  Box,
  GridLayout,
  TextButton,
  Typography,
} from '@wishket/design-system';
import { twMerge } from 'tailwind-merge';

import { BannerImage } from './TopBanner.parts';

import { Link } from '@/shared/Components';

interface TopBannerProps {
  imageUrl: string;
  title: string;
  link: string;
  linkText: string;
  backgroundColor: string;
  className?: string;
}

const TopBanner = ({
  imageUrl,
  title,
  link,
  linkText,
  backgroundColor,
  className,
}: TopBannerProps) => {
  const TitleComponent = (
    <Typography variant="body1" className="line-clamp-1 desktop:typo-subTitle2">
      {title}
    </Typography>
  );

  const LinkComponent = (
    <Link href={link} data-testid="top-banner-link">
      <TextButton text={linkText} trailingIcon="medium_arrow_right" />
    </Link>
  );

  return (
    <Box
      className={twMerge(
        `fixed left-0 top-0 z-30 flex w-screen bg-opacity-0 py-4 transition duration-1000 ease-in-out`,
        className
      )}
      style={{ backgroundColor }}
      data-testid="top-banner"
    >
      <GridLayout gridTemplateAreaClass="flex items-center gap-5">
        <BannerImage imageUrl={imageUrl} />
        <Box className="flex flex-1 flex-col justify-between gap-1 tablet:flex-row tablet:gap-5">
          {TitleComponent}
          {LinkComponent}
        </Box>
      </GridLayout>
    </Box>
  );
};

export default TopBanner;
